/**
 *
 *     |o     o    |          |
 * ,---|.,---..,---|,---.,---.|__/
 * |   |||   |||   ||---'`---.|  \
 * `---'``---|``---'`---'`---'`   `
 *       `---'    [media solutions]
 *
 * @copyright   (c) digidesk - media solutions
 * @link            https://www.digidesk.de
 */

const { Component, Mixin } = Shopware;

import template from './ddms-paypal-ext.html.twig';

Component.register(
    'ddms-paypal-ext',
    {
        template,

        mixins: [
            Mixin.getByName( 'notification' )
        ],

        data()
        {
            const curDate = new Date();
            const startDate = new Date( curDate.getFullYear(), curDate.getMonth() - 1, 1, 2, 0, 0 );

            return {
                isLoading:            false,
                processSuccess:       false,
                ddmsClient:           'none',
                ddmsMode:             'pp',
                ddmsStartDate:        startDate.toISOString().split('T')[0],
                ddmsClientOptions: [
                    { value: 'XB', label: 'XB' },
                    { value: 'HPS', label: 'HPS' },
                    { value: 'none', label: 'Alle' },
                ],
                ddmsModeOptions: [
                    { value: 'pp', label: 'Paypal Bestellungen' },
                    { value: 'all', label: 'Alle Bestellungen' },
                ],
            };
        },

        metaInfo()
        {
            return {
                title: this.$createTitle()
            };
        },

        methods: {
            onClickExport()
            {
                this.isLoading = true;

                const formData = new FormData();
                formData.append( "ddmsClient", this.ddmsClient );
                formData.append( "ddmsMode", this.ddmsMode );
                formData.append( "ddmsStartDate", this.ddmsStartDate );

                const basicHeaders = {
                    Authorization: `Bearer ${Shopware.Context.api.authToken.access}`
                };

                Shopware.Application.getContainer( 'init' ).httpClient
                        .post(
                            `_action/ddmspaypal`,
                            formData,
                            { headers: basicHeaders }
                        )
                        .then( ( response ) =>
                            {
                                var paramKey = document.createElement('input');
                                paramKey.type = 'hidden'
                                paramKey.name = 'k'
                                paramKey.value = 'def672b89dad038';

                                var paramType = document.createElement('input');
                                paramType.type = 'hidden'
                                paramType.name = 't'
                                paramType.value = 'text/csv';

                                var paramFilename = document.createElement('input');
                                paramFilename.type = 'hidden'
                                paramFilename.name = 'f'
                                paramFilename.value = 'postversand_liste.csv';

                                var paramContent = document.createElement('input');
                                paramContent.type = 'hidden'
                                paramContent.name = 'c'
                                paramContent.value = response.data;

                                const protocol = window.location.protocol;
                                const hostname = window.location.hostname;
                                const port = window.location.port;
                                const wwwHostname = hostname.startsWith('www.') ? hostname : 'www.' + hostname;
                                //const baseUrl = protocol + '//' + wwwHostname + (port ? ':' + port : '');
                                const baseUrl = protocol + '//' + hostname + (port ? ':' + port : '');

                                const formActionUrl = baseUrl + '/ddiso88591dl.php';

                                var form = document.createElement('form');
                                form.action = formActionUrl;
                                form.method = 'POST';
                                form.style.display = 'none';
                                form.appendChild(paramKey);
                                form.appendChild(paramType);
                                form.appendChild(paramFilename);
                                form.appendChild(paramContent);

                                document.body.appendChild( form );
                                form.submit();

                                setTimeout( function ()
                                {
                                    form.remove();
                                }, 1000 );

                                this.isLoading      = false;
                                this.processSuccess = true;
                            }
                        )
                        .catch(
                            ( exception ) =>
                            {
                                this.isLoading = false;
                                this.createNotificationError(
                                    {
                                        title:   this.$tc( 'ddms-paypal.error.title' ),
                                        message: exception
                                    }
                                )
                            }
                        );
            },

            exportFinish()
            {
                this.processSuccess = false;
            }
        }
    }
)
